///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useDispatch } from "react-redux";
import { format } from "date-fns";

import getStatusColor from "../../../../helpers/getStatusColor";
import {
  dateFormat,
  division as userDivision
} from "../../../../helpers/types";
import addTitleForTruncatedText from "../../../../helpers/addTitleForTruncatedText";
import { sortShipperHistory } from "../../../../slices/bidSummarySlice";

const BodyCell = ({ value, children, maxWidth, titleText }) => (
  <td
    className="truncate py-16 px-8 align-middle"
    style={{ maxWidth: maxWidth }}
    onMouseEnter={
      titleText
        ? e => addTitleForTruncatedText(e.currentTarget, titleText)
        : undefined
    }
    onMouseLeave={titleText ? e => (e.currentTarget.title = "") : undefined}
  >
    {value || children}
  </td>
);

function TableBody({ bids, division }) {
  const dispatch = useDispatch();

  return (
    <tbody data-testid="table-body">
      {bids.map(bid => {
        const statusColor = getStatusColor(bid.statusText);
        const bidDateFormat =
          division === userDivision.coy ? dateFormat.MMddyy : dateFormat.ddMMyy;

        return (
          <tr
            className="row bg-white"
            key={bid.bidId}
            onClick={() => {
              dispatch(sortShipperHistory({ field: null, order: null }));
              window.open(`/bid/${bid.bidId}/summary`, "_blank");
            }}
          >
            <BodyCell maxWidth="104px" titleText={bid.statusText}>
              <p
                style={{ backgroundColor: statusColor }}
                className="status inline-block mb-0 mr-6"
              ></p>
              {bid.statusText}
            </BodyCell>
            <BodyCell
              value={bid.bidName}
              maxWidth="120px"
              titleText={bid.bidName}
            />
            <BodyCell
              value={format(new Date(bid.openDateUTC + "Z"), bidDateFormat)}
              maxWidth="100px"
              titleText={format(new Date(bid.openDateUTC + "Z"), bidDateFormat)}
            />
            <BodyCell
              value={format(new Date(bid.closeDateUTC + "Z"), bidDateFormat)}
              maxWidth="110px"
              titleText={format(
                new Date(bid.closeDateUTC + "Z"),
                bidDateFormat
              )}
            />
          </tr>
        );
      })}
    </tbody>
  );
}

export default TableBody;
